import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import messages from './messages';
import Button from '../button/index';
import { DARK } from '../button/variants';
import { Warning, Tick } from '../../helpers/icon-dictionary';
import Modal from '../../components/modal/index';
import TeacherUnassign from '../../components/teacher-unassign/index';
import ConfirmationMessage from '../../components/confirmation-message/index';
import UserDelete from '../../components/user-delete/index';

const TeacherFooter = ({
    noOfSelectedTeachers = 0,
    handleOnTeacherUnassign,
    showModal,
    handleOnCloseModal,
    handleOnUnassignConfirm,
    isUserOperationModalOpen,
    isLoading,
    handleOnTeacherDeleteOpenModal,
    handleOnDeleteTeacher,
    operationType,
    teachersOperationSuccessConfirmation,
    intl,
    deletingTeacher }) => {
    let confirmation = <div />;

    switch (operationType) {
    case 'unassignTeacher':
        confirmation = isUserOperationModalOpen
            ? (
                <TeacherUnassign
                    handleOnCancel={handleOnCloseModal}
                    handleOnOk={handleOnUnassignConfirm}
                    icon={Warning}
                    isLoading={isLoading}
                    title={intl.formatMessage(messages.unassignTeachers)}>
                    <div>{intl.formatMessage(messages.selectedTeachersWillBe)} <span
                        className={css.highlight}>{intl.formatMessage(messages.unassigned)}</span> {intl.formatMessage(messages.loseAccessToProducts)}.
                    </div>
                </TeacherUnassign>)
            : (
                <ConfirmationMessage
                    handleOnCloseModal={teachersOperationSuccessConfirmation}
                    icon={Tick}
                    title={intl.formatMessage(messages.teachersUnassigned)} />);
        break;
    case 'deleteTeacher':
        confirmation = isUserOperationModalOpen
            ? (
                <UserDelete
                    handleOnCancel={handleOnCloseModal}
                    handleOnOk={handleOnDeleteTeacher}
                    heading={intl.formatMessage(messages.deleteConfirmation)}
                    icon={Warning}
                    isLoading={isLoading}
                    title={intl.formatMessage(messages.deleteTeachers)} />)
            : (
                <ConfirmationMessage
                    handleOnCloseModal={teachersOperationSuccessConfirmation}
                    icon={Tick}
                    title={intl.formatMessage(messages.teachersDeleted)} />);
        break;
    default:
        break;
    }

    return (
        <div className={css.teacherFooterComponent}>
            <div className={css.buttonContainer}>
                <Button
                    containerClassName={css.deleteTeachers}
                    disabled={noOfSelectedTeachers === 0 || deletingTeacher}
                    handleOnClick={handleOnTeacherDeleteOpenModal}
                    label={intl.formatMessage(messages.deleteTeachers)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.unassign}
                    disabled={noOfSelectedTeachers === 0 || deletingTeacher}
                    handleOnClick={handleOnTeacherUnassign}
                    label={intl.formatMessage(messages.unassign)}
                    variant={DARK}
                    visible />
            </div>
            <Modal show={showModal}>
                { confirmation }
            </Modal>
        </div>
    );
};

TeacherFooter.propTypes = {
    noOfSelectedTeachers: PropTypes.number,
    handleOnTeacherUnassign: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    handleOnUnassignConfirm: PropTypes.func,
    showModal: PropTypes.bool,
    isUserOperationModalOpen: PropTypes.bool,
    isLoading: PropTypes.bool,
    intl: intlShape.isRequired,
    handleOnDeleteTeacher: PropTypes.func,
    operationType: PropTypes.string,
    handleOnTeacherDeleteOpenModal: PropTypes.func,
    teachersOperationSuccessConfirmation: PropTypes.func,
    deletingTeacher: PropTypes.bool
};

export default injectIntl(TeacherFooter);



// WEBPACK FOOTER //
// ./app/components/teacher-footer/index.js